import { render, staticRenderFns } from "./mealBookInfo.vue?vue&type=template&id=db7423e8"
import script from "./mealBookInfo.vue?vue&type=script&lang=js"
export * from "./mealBookInfo.vue?vue&type=script&lang=js"
import style0 from "./mealBookInfo.vue?vue&type=style&index=0&id=db7423e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports